<template>
    <div class="flex-container--breadcrumbs-selected-vehicle">
        <div class="flex-container--select-vehicle-column">
            <div class="vehicles-list__item-name"><span v-if="selectedyear > 0 ">{{ selectedyear }}</span> {{ selectedmake.desc }} {{ selectedmodel.desc }}</div>
            <div class="vehicles-list__item-details-category-display">{{ selectedengine.desc }}</div>
        </div>
        <div class="flex-container--select-vehicle-column">
            <div class="product__tags tags tags--sm">
                <div class="tags__list tags__list-select-vehicle">
                    <button class="mobile-search__vehicle-picker change-vehicle__button" type="button" @click="this.$emit('openSelectVehicle')">
                        <span class="search__button-icon">
                            <svg width="20" height="20">
                                <path
                                    d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1
            c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2
            C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9
            c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0
            c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0
            C15.5,10.2,14,11.3,14,12z"
                                ></path>
                            </svg>
                        </span>
                        <span class="search__button-title">Select Vehicle</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
    
        ...mapGetters("vehicle", [
            "selectedyear",
            "selectedmake",
            "selectedmodel",
            "selectedengine",
        ]),
    }
}
</script>